// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/ru'

// Translation: Model > Access key manager (Russian)
export default Object.freeze({
	actions: {
		create: {
			hint: '',
			text: ''
		}
	},
	components: { accessKeyManagingDialog }
})
